import React, { lazy } from 'react';
import { PageOrchestrator } from '../orchestrator';

import { useLogin } from './hooks/useLogin';
import { useLoginSubmission } from './hooks/useLoginSubmission';
import { useSocialLogin } from './hooks/useSocialLogin';
import { useEmailFromSearchParams } from './hooks/utility';
import { LoginRecaptcha } from './components/LoginRecaptcha';
import { LoginMarketingConsent } from './components/MarketingConsent';

import { pages } from './cobranding.config';
import { ResetPasswordLink } from './components/ResetPasswordLink';

const baseLoginPage = lazy(() => import('./BasePage'));

const requiredComponents: Array<string> = [
  useLogin.name,
  useLoginSubmission.name,
  useSocialLogin.name,
  useEmailFromSearchParams.name,
  LoginRecaptcha.name,
  LoginMarketingConsent.name,
  ResetPasswordLink.name,
];

const OrchestratedLoginPage = () => {
  return (
    <PageOrchestrator
      fallback={baseLoginPage}
      pages={pages}
      requiredComponents={requiredComponents}
    />
  );
};

export default OrchestratedLoginPage;
